export default "__VITE_ASSET__C1TRk$HC__"